import { useContext, useState } from 'react'
import haxios from 'util/haxios'
import { Dropdown } from 'components/gsys-ui'
import { GlobalContext } from 'context/GlobalContext'

const CustomerDropdown = ({ selectedCustomer, setSelectedCustomer }) => {
  const { branch } = useContext(GlobalContext)
  const [debugMessage, setDebugMessage] = useState('')

  const loadOptions = async (search, loadedOptions, { page }) => {
    try {
      const res = await haxios.get('/dd/customers', {
        params: {
          branch,
          name: search,
          pageSize: 15,
          pageIndex: page - 1
        }
      })

      if (!res || !res.response) {
        return { options: [], hasMore: false }
      }

      // Filter out invalid customer records (empty KeyCode/Name)
      const validCustomers = res.response.filter(p =>
        p.KeyCode && p.Name && p.KeyCode.trim() !== '' && p.Name.trim() !== ''
      );

      const newOptions = validCustomers.map(p => ({
        label: `[${p.KeyCode}] ${p.Name}`,
        value: p.KeyCode,
        // Only include location if it exists and has valid data
        location: p.Loc && p.Loc.length > 0 && p.Loc[0] &&
          typeof p.Loc[0].lat === 'number' && typeof p.Loc[0].lon === 'number' ?
          {
            lat: p.Loc[0].lat,
            lng: p.Loc[0].lon
          } : null
      }))

      setDebugMessage(`Found ${newOptions.length} customers`)

      return {
        options: newOptions,
        hasMore: page < (res.pagination?.totalPages || 1),
        additional: {
          page: page + 1
        }
      }
    } catch (error) {
      console.error('Error loading customers:', error)
      setDebugMessage('Error: ' + error.message)
      return {
        options: [],
        hasMore: false,
        additional: { page: 1 }
      }
    }
  }

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex-1 min-w-0">
        <Dropdown
          placeholder="Type to search..."
          value={selectedCustomer}
          onChange={setSelectedCustomer}
          loadOptions={loadOptions}
          withPagination={true}
          additional={{
            page: 1,
          }}
          noOptionsMessage={() => "No customers found. Try a different search term."}
          loadingMessage={() => "Loading customers..."}
        />
      </div>
      {debugMessage && (
        <div className="text-xs text-gray-500">{debugMessage}</div>
      )}
    </div>
  )
}

export default CustomerDropdown